import { axiosV2 } from 'interceptors/axios';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export const checkPartnerExists =
  (societyId: string, cif: string) => async (dispatch: any) => {
    const query = { params: { societyId, cif } };

    try {
      const { data } = await axiosV2.get('/partners/exists', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
